import React from 'react';
import { AnimatedIcon } from '@shell-b2c/web-design-system';

export const ConeAnimation = (props) => {
  return <AnimatedIcon type="cone" {...props} />;
};

export default ConeAnimation;
